import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import AdminProducts from "./AdminProducts";
import AdminOrders from "./AdminOrders";

import "./AdminDashboard.css";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState("products");

  const username = localStorage.getItem("starGoldAdminUsername") || "Admin";

  const handleLogout = () => {
    localStorage.removeItem("starGoldAdminToken");
    localStorage.removeItem("starGoldAdminUsername");
    localStorage.removeItem("starGoldAdminRole");

    navigate("/admin/login");
  };

  return (
    <div className="admin-dashboard">
      {/* SIDEBAR */}

      <aside className="admin-sidebar">
        <div className="admin-brand">
          <div className="admin-sidebar-logo">STAR GOLD</div>

          <p className="admin-sidebar-label">ADMIN PANEL</p>
        </div>

        <nav className="admin-navigation">
          <button
            type="button"
            className={
              activeSection === "products"
                ? "admin-nav-item active"
                : "admin-nav-item"
            }
            onClick={() => setActiveSection("products")}
          >
            <span className="admin-nav-icon">◇</span>

            <span>Products</span>
          </button>

          <button
            type="button"
            className={
              activeSection === "orders"
                ? "admin-nav-item active"
                : "admin-nav-item"
            }
            onClick={() => setActiveSection("orders")}
          >
            <span className="admin-nav-icon">▱</span>

            <span>Orders</span>
          </button>
        </nav>

        <div className="admin-sidebar-bottom">
          <div className="admin-store-status">
            <span className="status-dot"></span>

            <div>
              <strong>Store Online</strong>
              <small>STAR GOLD</small>
            </div>
          </div>

          <button
            type="button"
            className="admin-logout-button"
            onClick={handleLogout}
          >
            <span>↪</span>
            Logout
          </button>
        </div>
      </aside>

      {/* MAIN CONTENT */}

      <main className="admin-main">
        {/* HEADER */}

        <header className="admin-header">
          <div className="admin-header-title">
            <p className="admin-header-eyebrow">STAR GOLD / ADMINISTRATION</p>

            <h1>
              {activeSection === "products"
                ? "Product Management"
                : "Order Management"}
            </h1>

            <p className="admin-header-description">
              {activeSection === "products"
                ? "Manage your jewellery collection, pricing and stock."
                : "Review and manage customer orders."}
            </p>
          </div>

          <div className="admin-user">
            <div className="admin-user-avatar">
              {username.charAt(0).toUpperCase()}
            </div>

            <div className="admin-user-details">
              <span>Signed in as</span>

              <strong>{username}</strong>
            </div>
          </div>
        </header>

        {/* PAGE CONTENT */}

        <section className="admin-content">
          {activeSection === "products" && <AdminProducts />}

          {activeSection === "orders" && <AdminOrders />}
        </section>
      </main>
    </div>
  );
};

export default AdminDashboard;
